<template>
    <form-row title="Drainage" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_drainage"
                v-model="has_drainage"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_drainage" class="pt-6 pb-2">
                <buyer-seller-split
                    label="Who is Responsible for Improvements?"
                    field="utilities_drainage_who_responsible"
                    :value="commercial.utilities_drainage_who_responsible"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../buyer-seller-split.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerSplit,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_drainage: this.commercial.has_drainage,
        }
    },
}
</script>
